class LocationsDrawer extends Drawer {
  constructor() {
    super();
  }

  open(triggeredBy) {
    super.open(triggeredBy);

    setTimeout(() => {
      const countryFilterInput = this.querySelector('#country-filter-input');
      if (countryFilterInput && typeof countryFilterInput.focus === 'function') {
        countryFilterInput.focus();
      }
    }, 250);
  }

  close() {
    super.close();
    // Clean up any search-specific state
    this.clearSearchInput();
  }

  clearSearchInput() {
    const countryFilterInput = this.querySelector('#country-filter-input');
    if (countryFilterInput) {
      countryFilterInput.value = '';
    }
  }
}

customElements.define('locations-drawer', LocationsDrawer);
